import React, { Component } from 'react';

import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';

import ReduxConnect from 'Demora/redux-connect';

import socialHttp from '../../../../../utils/socialHttp';

import Image from 'Demora/image';

import { withRouter } from 'react-router-dom';

import modal from 'Demora/modals/modal';

import Loading from 'Demora/Loading';

class ShowFeels extends Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);

		let feels = this.props.feels;

		let splitobj = this.props.obj.split('-');

		let root = splitobj.slice(0, 2).join('-');

		let obj = splitobj.slice(0, 3).join('-');

		let comment;

		if (splitobj.length == 4) {
			comment = splitobj.slice(0, 4).join('-');
		}

		this.state = {
			activeTab: 'l',
			root: root,
			obj: obj,
			comment: comment,
		};
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab,
			});

			if (this.areFeelsEmpty(tab)) {
				setTimeout(this.getData.bind(this), 250);
			}
		}
	}

	getObj() {
		let s = this.state;

		let obj = this.props.feed[s.root].p[s.obj];

		if (s.comment) {
			obj = obj.c.p[s.comment];
		}

		return obj;
	}

	areFeelsEmpty(tab) {
		if (Object.keys(this.getObj().a[tab].a) == 0) {
			return true;
		}
	}

	componentDidMount() {
		if (this.areFeelsEmpty(this.state.activeTab)) {
			this.getData();
		}
	}

	getData() {
		let obj = this.getObj();

		let act = this.state.activeTab;

		let sc = obj.a[act].startCursor;

		let before = !sc ? '' : '&before=' + sc;

		socialHttp(
			'get',
			'/data/feed/' +
				this.props.obj +
				'/feels/' +
				this.state.activeTab +
				'?first=25' +
				before
		).catch((error) => {});
	}

	showMoreFeels() {
		this.getData();
	}

	clickOnUser(user, e) {
		e.preventDefault();

		this.props.history.push('/profile/' + user.id + '-u');

		setTimeout(() => {
			modal.close('showFeels');
		}, 10);
	}

	render() {
		let feels = this.props.feels;

		let obj = this.getObj();

		let act = this.state.activeTab;

		let feelsForObject = obj.a[act];

		let that = this;

		let f = Object.keys(feelsForObject.a).filter((user) => {
			if (!that.props.users[user]) {
				return false;
			}

			let tfeel = feelsForObject.a[user];

			return !tfeel.d;
		});

		let users = f.map((key) => {
			let user = that.props.users[key];

			return (
				<li className='text-center float-left m-1' key={key}>
					<a href='#' onClick={that.clickOnUser.bind(that, user)}>
						<img
							src={Image(user.image, 50)}
							title={user.f}
							className='img-responsive tip rounded'
						/>
						<div className='first_name'>{user.first_name}</div>
					</a>
				</li>
			);
		});

		let next = feelsForObject.c - users.length;

		return (
			<div>
				<Nav tabs style={{ marginBottom: '1rem' }}>
					{feels.order.map((v) => {
						if (!obj.a[v]) {
							return '';
						}

						return (
							<NavItem key={v}>
								<NavLink
									className={classnames({ active: this.state.activeTab === v })}
									onClick={() => {
										this.toggle(v);
									}}
								>
									{feels.feels[v].g}s{' '}
									{obj.a[v].c > 0 ? '(' + obj.a[v].c + ')' : ''}
								</NavLink>
							</NavItem>
						);
					})}
				</Nav>
				<div className='card card-body panel-white post'>
					<div className='row'>
						<div className='col-12'>
							{feelsForObject.c == 0 ? (
								<div className='text-center'>
									There are no users for this interaction
								</div>
							) : f.length == 0 ? (
								<div
									className='card panel-white post panel-shadow text-center'
									style={{ padding: '30px 0' }}
								>
									<Loading />
								</div>
							) : (
								<div>
									<ul
										style={{
											listStyle: 'none',
											display: 'inline-block',
											background: '#fff',
										}}
									>
										{users}
									</ul>
									{users.length > 0 &&
										(next > 0 ? (
											<div className='text-center'>
												<button
													className='btn btn-primary btn-small'
													onClick={this.showMoreFeels.bind(this)}
												>
													Show more interactions
												</button>
											</div>
										) : (
											''
										))}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(
	ReduxConnect(ShowFeels, {
		feels: 'feels',
		feed: 'feed',
		users: 'users',
	})
);
